// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14ac9379","455":"95198ec1","644":"b8f283bd"}[chunkId] + ".chunk.js";
};